/* Maison Brogi — Discovery Set gallery carousel (port of original `l9`). */
(function () {
  'use strict';
  // Literal classes for Tailwind: border-navy border-transparent opacity-60 hover:opacity-100
  var ACTIVE = ['border-navy'];
  var INACTIVE = ['border-transparent', 'opacity-60', 'hover:opacity-100'];

  function init(root) {
    if (root.__brogiDs) return;
    root.__brogiDs = true;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ds-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ds-thumb]'));
    if (slides.length < 2) return;
    var i = 0;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle('hidden', k !== i);
        if (k === i) { var img = s.querySelector('img'); if (img) img.loading = 'eager'; }
      });
      thumbs.forEach(function (t, k) {
        ACTIVE.forEach(function (c) { t.classList.toggle(c, k === i); });
        INACTIVE.forEach(function (c) { t.classList.toggle(c, k !== i); });
      });
    }
    var prev = root.querySelector('[data-ds-prev]'), next = root.querySelector('[data-ds-next]');
    prev && prev.addEventListener('click', function () { show(i - 1); });
    next && next.addEventListener('click', function () { show(i + 1); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
  }
  function boot(ctx) { (ctx || document).querySelectorAll('[data-discovery-gallery]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
